/**
 * Normaliza parámetros de búsqueda para api/NovedadesLiquidacion/BuscarNovedades.
 * El proxy reenvía el query string tal cual; el API remoto espera PascalCase y TamanoPagina.
 */
export function normalizeBuscarNovedadesParams(request) {
  const params = request ? { ...request } : {};

  const pageSize =
    params.tamanoPagina ?? params.TamanoPagina
    ?? params.cantidadPagina ?? params.CantidadPagina;
  const pageNumber = params.numeroPagina ?? params.NumeroPagina;

  if (pageSize != null && params.TamanoPagina == null) {
    params.TamanoPagina = pageSize;
  }
  if (pageNumber != null && params.NumeroPagina == null) {
    params.NumeroPagina = pageNumber;
  }

  delete params.numeroPagina;
  delete params.tamanoPagina;
  delete params.cantidadPagina;

  const pairs = [
    ['fechaDesde', 'FechaDesde'],
    ['fechaHasta', 'FechaHasta'],
    ['idSeller', 'IdSeller'],
    ['idEstado', 'IdEstado'],
    ['ordenDeReferencia', 'OrdenDeReferencia'],
    ['idTipoNovedad', 'IdTipoNovedad'],
    ['buscaTodo', 'BuscaTodo'],
    ['idLiquidacion', 'IdLiquidacion'],
  ];

  pairs.forEach(([camel, pascal]) => {
    if (params[camel] != null && params[pascal] == null) {
      params[pascal] = params[camel];
      delete params[camel];
    }
  });

  return params;
}
